import type { Environment } from 'types/environment'
import type { StoryblokContent } from '~/types/storyblok'
import type Storyblok from '~/types/vendors/storyblok'
import { zodUnions } from 'types/environment'

export type marketCode = Environment.CountryCode
/** @deprecated Use uppercase Environment.CountryCode instead */
export type legacyMarketCode = Lowercase<Environment.CountryCode>

export type AllMarketsContent = StoryblokContent & {
  [_key in marketCode | legacyMarketCode]: Storyblok.Text
} & {
  component: 'all-markets'
}

export type AllMarkets = {
  [_key in marketCode]: string
}

const markets = zodUnions.countryCodes

export function normalizeAllMarkets(content: AllMarketsContent): AllMarkets {
  const normalized: Partial<AllMarkets> = {}

  for (const maybeKey of Object.keys(content)) {
    // Try uppercase first (new format)
    let exists = markets.safeParse(maybeKey)
    let normalizedKey: marketCode | undefined
    const contentKey = maybeKey

    if (exists.success) {
      normalizedKey = exists.data as marketCode
    }
    else {
      // Fallback: try uppercase conversion for legacy lowercase keys
      exists = markets.safeParse(maybeKey.toUpperCase())
      if (exists.success) {
        normalizedKey = exists.data as marketCode
      }
    }

    if (normalizedKey) {
      const value = content[contentKey as keyof AllMarketsContent] as string
      if (value) {
        normalized[normalizedKey] = value
      }
    }
  }

  return normalized as AllMarkets
}
